export function textColor(bgColor) {
  switch (bgColor) {
    case 'var(--white)':
      return 'var(--black)'
    case 'var(--black)':
      return 'var(--white)'
    case 'var(--light-gray)':
      return 'var(--black)'
    case 'var(--primary)':
      return 'var(--white)'
    case 'var(--secondary)':
      return 'var(--black)'
    case 'var(--yellow)':
      return 'var(--black)'
    default:
      return 'var(--black)'
  }
}

export function dotsBackground(bgColor) {
  switch (bgColor) {
    case 'var(--white)':
      return 'var(--yellow)'
    case 'var(--black)':
      return 'var(--yellow)'
    case 'var(--light-gray)':
      return 'var(--yellow)'
    case 'var(--primary)':
      return 'var(--yellow)'
    case 'var(--secondary)':
      return 'var(--yellow)'
    case 'var(--yellow)':
      return 'var(--primary)'
    default:
      return 'var(--yellow)'
  }
}
